<div class="card">
    <div class="card-header mb-2">
        <span>{{title}}
            <i class="pi pi-info-circle ml-2" tooltipPosition="{{tipLocation}}" *ngIf="toolTipPath" pTooltip="{{toolTipPath | translate}}" ></i>
        </span>
    </div>
    <div class="surface-section">
        <ul class="list-none p-0 m-0">
            <li class="flex justify-content-between w-full py-1 px-2 border-top-1 surface-border flex-wrap">
                <div class="text-500 w-6 md:w-5 font-medium">{{cols[0]}}</div>
                <div class="flex justify-content-end">
                    <div class="text-900 md:flex-order-0 flex-order-1" *ngIf="items?.length > 0; else errorBlock">{{cols[1] ?? ''}}</div>
                    <ng-template #errorBlock>
                        <div class="text-900">Not Found</div>
                    </ng-template>
                </div>
            </li>
            <li class="flex justify-content-between align-items-center py-1 px-2 border-top-1 surface-border flex-wrap" *ngFor="let item of items; let i = index;">
                <div class="flex">
                    <div *ngIf="colors" class="w-1rem h-1rem border-round " [ngStyle]="{'background-color': colors[i].hex, 'box-shadow': colors[i].rgba}"></div>
                    <div class="text-500 w-6 md:w-5 font-medium ml-2">{{item?.name}}</div>
                </div>
                <div class="flex justify-content-end">
                    <div>{{item?.value | number:'1.0':'en-US' ?? 'Not Found'}}</div>
                </div>
            </li>
        </ul>
    </div>
</div>